





















import Vue, { PropType } from "vue"
import PPlainBoard from "./local/PPlainBoard.vue"
import Container from "~/components/guideline/frame/Container.vue"
import PProjectListForPublicCorporationProfile, {
  ClickFavoriteIconEmitArgument,
} from "~/components/custom/projectList/PProjectListForPublicCorporationProfile.vue"
import { BackendApi } from "~/backendApis"
import { CorporationAccountView, ProjectView } from "~/backendApis/viewModel"
import { projectListLogic } from "~/uiLogics/projectList/projectListLogic"
import ProgressCircular from "~/components/guideline/loading/ProgressCircular.vue"

interface DataType {
  projects: ProjectView[]
  page: number
  isFetchingProjectList: boolean
  isFetchableNext: boolean
  isProjectListInitialized: boolean
}

export default Vue.extend({
  components: {
    PPlainBoard,
    Container,
    PProjectListForPublicCorporationProfile,
    ProgressCircular,
  },
  props: {
    corporationAccount: {
      type: Object as PropType<CorporationAccountView>,
      required: true,
    },
  },
  data(): DataType {
    return {
      projects: [],
      page: 1,
      isFetchingProjectList: false,
      isFetchableNext: false,
      isProjectListInitialized: false,
    }
  },
  computed: {
    favoriteProjectIds() {
      return this.$clStores.favoriteProjectList.getters.getIdList()
    },
    universalCorporationId(): string {
      return this.$route.params.universalCorporationId
    },
  },
  watch: {
    "$clAuth.finishedAuthProcess": {
      handler() {
        if (this.$clAuth.loggedIn) {
          this.$clStores.favoriteProjectList.actions.refreshList()
        }
      },
      immediate: true,
    },
  },
  beforeMount() {
    this.initializeProjectList()
  },
  methods: {
    toggleFavoriteStatus({ projectId }: ClickFavoriteIconEmitArgument) {
      this.$clStores.favoriteProjectList.actions.toggleFavoriteStatus(projectId)
    },
    async fetchProjectList() {
      this.isFetchingProjectList = true
      const {
        list,
        numberOfTotalPages,
      } = await BackendApi.general.projectSearch.read.getProjectListByCorporationId(
        {
          universalCorporationId: this.universalCorporationId,
          page: this.page,
        }
      )
      this.isFetchingProjectList = false

      this.projects = projectListLogic(this.projects).append(list)

      this.isFetchableNext = numberOfTotalPages > this.page
    },
    async initializeProjectList() {
      this.page = 1
      this.projects = []
      this.isProjectListInitialized = false

      await this.fetchProjectList()
      this.isProjectListInitialized = true
    },
    fetchNext() {
      if (this.isFetchableNext && !this.isFetchingProjectList) {
        this.page += 1
        this.fetchProjectList()
      }
    },
  },
})
